export {
    ButtonText,
    IconWrapper,
    StyledButton,
    StyledIcon,
    StyledResetButton,
    Wrapper,
} from './styles';
